import ToolTip from "components/design/toolTip";
import { ReactNode } from "react";

const LOCKED_FIELD_MESSAGE =
  "This field has already been completed by the customer and can no longer be edited.";

export const IncorporationLockedFieldTooltip = ({
  isLocked,
  children,
}: {
  isLocked: boolean;
  children: ReactNode;
}) => {
  if (!isLocked) {
    return <>{children}</>;
  }

  return (
    <ToolTip text={<div className="t-w-64">{LOCKED_FIELD_MESSAGE}</div>}>
      <span className="t-block">{children}</span>
    </ToolTip>
  );
};
